module.exports = __webpack_public_path__ + "img/fauteuil-5.6c77a51a.jpg";